export const Events = {
    PressingTile : "pressingTile",
    DraggingTile : "draggingTile",
    PressingViewport : "pressingViewport",
    DraggingViewport : "draggingViewport",
    
}

export const dragThreshold = 1;
